import { useEffect, useMemo, useState } from 'react';

function normalizeHash(hash) {
  const raw = (hash || '').trim();
  if (!raw) return '/';
  if (raw === '#') return '/';
  if (raw.startsWith('#/')) return raw.slice(1);
  return raw.startsWith('#') ? raw.slice(1) : raw;
}

export function useHashRoute() {
  const [hash, setHash] = useState(() => window.location.hash);

  useEffect(() => {
    const onChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return useMemo(() => normalizeHash(hash), [hash]);
}

